export enum Flags {
	isUploadLogoActivated = "isUploadLogoActivated",
}
